import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchContacts = () => {
    const params = {
        fields: JSON.stringify(["*"]),
        expand: JSON.stringify(["phone_nos"]),
        limit: 0,
    };

    return axios.get(`/resource/Contact`, { params });
};

export const useContacts = () => {
    return useQuery(["getContacts"], async () => {
        const data = await fetchContacts();
        return data.data.data;
    });
};

const fetchCustomers = () => {
    const params = {
        fields: JSON.stringify(["*"]),
        filters: JSON.stringify([
            ["Customer", "customer_name", "not like", "%table-customer%"],
        ]),
        expand: JSON.stringify(["phone_nos"]),
        limit: 0,
    };

    return axios.get(`/resource/Customer`, { params });
};

export const useCustomers = () => {
    return useQuery(
        ["getCustomers"],
        async () => {
            const data = await fetchCustomers();
            return data.data.data;
        },
        {
            cacheTime: 0,
            refetchOnMount: true,
        }
    );
};

export const useCreateCustomerWithAddress = () => {
    return useMutation(
        async ({
            customer_name,
            mobile_no,
            address_line1,
            address_line2,
            city,
            customer_type = "Individual",
            order_name,
        }) => {
            const payload = {
                customer_name,
                mobile_no,
                address_line1,
                address_line2,
                city,
                customer_type,
                order_name,
            };
            const data = await axios.post(
                `method/restaurant_management.api.create_customer`,
                payload
            );
            return data;
        }
    );
};
